module.exports = __webpack_public_path__ + "img/icon2.efea8aa6.png";